import React, { Component } from "react";
import Logout from "../../assets/logout.svg";
import Back from "../../assets/back.svg";
// import Edit from '../assets/edit.svg'
import Plus from "../../assets/plus.svg";
// import suspectlistwhite from '../assets/suspectlistwhite.svg'
// import blocklistwhite from '../assets/blocklistwhite.svg'
import suspect from "../../assets/suspectwhite.svg";
import block from "../../assets/blockwhite.svg";

import SuspectCellButton from "../../components/SuspectCellButton";
import BlockCellButton from "../../components/BlockCellButton";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
// import NumberFormat from 'react-number-format';
import CustomButton from "../../components/CustomButton";
// import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { Modal, Form } from "react-bootstrap";
import Cancel from "../../assets/cancel.svg";
import Tick from "../../assets/tick.svg";
import { WhisperSpinner } from "react-spinners-kit";
import { toast } from "react-toastify";
import Paginator from "../../components/Paginator";
// import filter from '../assets/filter.png'
import accessdenied from "../../assets/accessdenied.svg";
import "../../App1.css";
import Tooltip from "@mui/material/Tooltip";
import {
  BaseUrl,
  Authorization,
  isUser,
  LogoutFunction,
  ClubAuthorization,
} from "../../static.js";

const mobileRegex = RegExp(/09(0[0-9]|1[1-9]|2[1-9]|3[0-9]|9[0-9])-?[0-9]{7}/);

export default class SuspectsOrBlocks extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gridLocaleText: {
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",
        andCondition: "و",
        orCondition: "یا",
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",
        columns: "ستون ها",
        filters: "فیلترها",
        group: "گروه",
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",
      },
      rowData: [],
      columnDefs: [],
      columnDefs1: [
        {
          headerName: "موبایل",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام مشترک",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "suspectCell",
          cellRendererParams: {
            deleteItem: this.deleteItem.bind(this),
            blockItem: this.blockItem.bind(this),
          },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      columnDefs2: [
        {
          headerName: "موبایل",
          field: "phone",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "نام مشترک",
          field: "name",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "تاریخ ایجاد",
          field: "persianCreatedOn",
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
        {
          headerName: "عملیات",
          field: "id",
          cellRenderer: "blockCell",
          cellRendererParams: { deleteItem: this.deleteItem.bind(this) },
          sortable: true,
          filter: false,
          resizable: false,
          cellStyle: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderStyle: "solid",
            borderWidth: "0px 0px 0px 1px",
            borderColor: "var(--gray1)",
          },
          lockPosition: true,
        },
      ],
      frameworkComponents: {
        suspectCell: SuspectCellButton,
        blockCell: BlockCellButton,
      },
      ModalShow: false,
      modalType: 0,
      writingProgress: false,
      dataLoading: true,
      currentPage: 0,
      totalPages: 0,
      ModalShow2: false,
      CPhoneErrorText: "",
      CPhoneValue: "",
      isSuspectCheck: true,
      currentId: null,
      currentPhone: null,
      accessDenied: false,
      currentRestaurantId: null,
    };

    this.tableContainer = React.createRef();
    this.GetSuspectAccounts = this.GetSuspectAccounts.bind(this);
    this.textHandleChange = this.textHandleChange.bind(this);
  }

  deleteItem(id) {
    this.setState({ ModalShow: true, modalType: "delete", currentId: id });
  }

  blockItem(id, phone) {
    this.setState({
      ModalShow: true,
      modalType: "transfer",
      currentId: id,
      currentPhone: phone,
    });
  }

  onAddSuspect() {
    this.setState({
      writingProgress: false,
      CPhoneErrorText: "",
      CPhoneValue: "",
      ModalShow: true,
      modalType: "suspect",
    });
  }

  onAddBlock() {
    this.setState({
      writingProgress: false,
      CPhoneErrorText: "",
      CPhoneValue: "",
      ModalShow: true,
      modalType: "block",
    });
  }

  componentDidMount() {
    this.getBusinessInfo();
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.id,
    };
    data = Object.assign(data, Authorization());

    fetch(BaseUrl + "findBusinessWithCode", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState(
            {
              currentRestaurantId: result.result[0].id,
              priceUnit: result.result[0].rtlPriceTitle,
            },
            () => {
              this.GetSuspectAccounts(1);
            }
          );
        } else if (result.status === 401) {
          LogoutFunction();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  GetSuspectAccounts(page) {
    this.setState({ dataLoading: true });

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/SuspectBlock/GetSuspectAccounts?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else if (res.status === 403) {
          this.setState({ accessDenied: true });
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetSuspectAccounts: ", result);
        if (result.isSuccessfull) {
          this.setState({
            isSuspectCheck: true,
            dataLoading: false,
            columnDefs: this.state.columnDefs1,
            rowData: result.results[0].pageData,
            currentPage: result.results[0].currentPage,
            totalPages: result.results[0].totalPages,
          });
        } else {
          this.props.history.push("/Restaurants");
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  GetBlockAccounts(page) {
    this.setState({ dataLoading: true });
    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/SuspectBlock/GetBlockAccounts?restaurantId=" +
        this.state.currentRestaurantId +
        "&page=" +
        page,
      {
        method: "GET",
        headers: { Authorization: jsonString },
      }
    )
      .then((res) => {
        if (res.status === 401) {
          LogoutFunction();
        } else {
          return res.json();
        }
      })
      .then((result) => {
        console.log("GetBlockAccounts: ", result);
        if (result.isSuccessfull) {
          this.setState({
            isSuspectCheck: false,
            dataLoading: false,
            columnDefs: this.state.columnDefs2,
            rowData: result.results[0].pageData,
            currentPage: result.results[0].currentPage,
            totalPages: result.results[0].totalPages,
          });
        } else {
          this.props.history.push("/Restaurants");
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ dataLoading: false });
      });
  }

  onFirstPageClick() {
    if (this.state.isSuspectCheck) this.GetSuspectAccounts(1);
    else this.GetBlockAccounts(1);
  }

  onPreviousPageClick() {
    if (this.state.isSuspectCheck)
      this.GetSuspectAccounts(this.state.currentPage - 1);
    else this.GetBlockAccounts(this.state.currentPage - 1);
  }

  onNextPageClick() {
    if (this.state.isSuspectCheck)
      this.GetSuspectAccounts(this.state.currentPage + 1);
    else this.GetBlockAccounts(this.state.currentPage + 1);
  }

  onLastPageClick() {
    if (this.state.isSuspectCheck)
      this.GetSuspectAccounts(this.state.totalPages);
    else this.GetBlockAccounts(this.state.totalPages);
  }

  onBack() {
    this.props.history.push('/Restaurants/'+this.props.match.params.id+'/Club')
  }

  onLogout() {
    LogoutFunction();
  }

  onFirstDataRendered(params) {
    try {
      params.api.sizeColumnsToFit();
      window.setTimeout(() => {
        const colIds = params.columnApi.getAllColumns().map((c) => c.colId);
        params.columnApi.autoSizeColumns(colIds, false);

        let cols = params.columnApi.getColumnState();
        let width = 0;
        cols.forEach((element) => {
          width += element.width;
        });
        if (
          width <
          this.tableContainer.current.getBoundingClientRect().width - 10
        ) {
          let def =
            this.tableContainer.current.getBoundingClientRect().width -
            10 -
            width;
          if (def > cols.length) {
            let newwidth = def / cols.length;
            cols.forEach((element) => {
              params.columnApi.setColumnWidth(
                element.colId,
                element.width + newwidth
              );
            });
          } else {
            params.columnApi.setColumnWidth(cols[0].colId, cols[0].width + def);
          }
        }
      }, 50);
    } catch (error) {}
  }

  hideModal() {
    this.setState({ ModalShow: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  onConfirm() {
    if (this.state.CPhoneValue && !mobileRegex.test(this.state.CPhoneValue)) {
      this.setState({ CPhoneErrorText: "شماره موبایل نامعتبر است" }, () => {
        toast.error(this.state.CPhoneErrorText, {
          position: toast.POSITION.BOTTOM_RIGHT,
          hideProgressBar: true,
          autoClose: 8000,
          toastClassName: "toast",
        });
      });
      return;
    } else {
      this.setState({ CPhoneErrorText: "" });
    }
    this.setState({ writingProgress: true });
    let apiname = "";
    if (this.state.modalType === "suspect") apiname = "AddSuspectAccount";
    else apiname = "AddBlockAccount";

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch(
      "https://94.101.187.196/api/SuspectBlock/" +
        apiname +
        "?restaurantId=" +
        this.state.currentRestaurantId +
        "&phone=" +
        this.state.CPhoneValue,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: jsonString,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          toast.success(
            this.state.modalType === "suspect"
              ? "تلفن مورد نظر با موفقیت به لیست مشکوکین اضافه شد"
              : "تلفن مورد نظر با موفقیت به لیست مسدودین اضافه شد",
            {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            }
          );
          this.setState({ writingProgress: false, ModalShow: false }, () => {
            // this.GetSuspectAccounts(this.state.currentPage)
            if (this.state.isSuspectCheck)
              this.GetSuspectAccounts(this.state.currentPage);
            else this.GetBlockAccounts(this.state.currentPage);
          });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });
  }

  onConfirmQuestion() {
    this.setState({ writingProgress: true });
    let apiname = "";
    if (this.state.modalType === "delete") {
      if (this.state.isSuspectCheck)
        apiname =
          "DeleteSuspectAccount?restaurantId=" +
          this.state.currentRestaurantId +
          "&id=" +
          this.state.currentId;
      else
        apiname =
          "DeleteBlockAccount?restaurantId=" +
          this.state.currentRestaurantId +
          "&id=" +
          this.state.currentId;
    } else
      apiname =
        "MoveSuspectAccountToBlock?restaurantId=" +
        this.state.currentRestaurantId +
        "&id=" +
        this.state.currentId +
        "&phone=" +
        this.state.currentPhone;

    let data = isUser
      ? {
          businessCode: this.props.match.params.id,
        }
      : {};
    data = Object.assign(data, ClubAuthorization());
    let jsonString = "SepandPlus " + btoa(JSON.stringify(data));

    fetch("https://94.101.187.196/api/SuspectBlock/" + apiname, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: jsonString,
      },
      // body: JSON.stringify(data)
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.isSuccessfull) {
          let message = "";
          if (this.state.modalType === "delete") {
            if (this.state.isSuspectCheck)
              message = "تلفن مورد نظر از لیست مشکوکین حذف شد";
            else message = "تلفن مورد نظر از لیست مسدودین حذف شد";
          } else message = "تلفن مورد نظر به لیست مسدودین انتقال پیدا کرد";
          toast.success(message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false, ModalShow: false }, () => {
            if (this.state.isSuspectCheck)
              this.GetSuspectAccounts(this.state.currentPage);
            else this.GetBlockAccounts(this.state.currentPage);
          });
        } else if (result.errorMessage) {
          toast.error(result.errorMessage, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.setState({ writingProgress: false });
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ writingProgress: false });
      });
  }

  render() {
    if (!this.state.accessDenied) {
      return (
        <div className="Login">
          <div className="header">
            <div
              onClick={this.onBack.bind(this)}
              className="linkStyle backButton"
            >
              <img
                src={Back}
                alt=""
                className="backButtonIcon"
                style={{ transform: "rotate(180deg)" }}
              />
              بازگشت
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                alignItems: "center",
              }}
            >
              <Tooltip title="خروج">
                <div
                  onClick={this.onLogout.bind(this)}
                  className="linkStyle backButton"
                >
                  <img src={Logout} alt="" className="backButtonIcon" />
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="LoginContent">
            <div className="RestaurantsListTitle">
              {this.state.isSuspectCheck
                ? "لیست تلفن‌های مشکوک"
                : "لیست تلفن‌های مسدود"}
            </div>
            <div className="RestaurantsListSubTitle">
              {this.state.isSuspectCheck
                ? "مشاهده، ویرایش و اضافه کردن به لیست تلفن‌های مشکوک"
                : "مشاهده، ویرایش و اضافه کردن به لیست تلفن‌های مسدود"}
            </div>
          </div>
          <div className="pageContents" ref={this.tableContainer}>
            {!this.state.dataLoading && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <div>
                  <CustomButton
                    title={
                      this.state.isSuspectCheck
                        ? "تلفن‌ مشکوک جدید"
                        : "تلفن‌ مسدود جدید"
                    }
                    imgHeight={20}
                    imgWidth={25}
                    flexDirection="row-reverse"
                    minHeight="35px"
                    img={Plus}
                    onClick={
                      this.state.isSuspectCheck
                        ? this.onAddSuspect.bind(this)
                        : this.onAddBlock.bind(this)
                    }
                  />
                </div>
                {this.state.isSuspectCheck && (
                  <div>
                    <CustomButton
                      title="نمایش لیست مسدودها"
                      imgHeight={20}
                      imgWidth={25}
                      flexDirection="row-reverse"
                      minHeight="35px"
                      img={block}
                      onClick={() =>
                        this.GetBlockAccounts(this.state.currentPage)
                      }
                    />
                  </div>
                )}
                {!this.state.isSuspectCheck && (
                  <div>
                    <CustomButton
                      title="نمایش لیست مشکوک‌ها"
                      imgMarginLeft={4}
                      imgHeight={20}
                      imgWidth={25}
                      flexDirection="row-reverse"
                      minHeight="35px"
                      img={suspect}
                      onClick={() =>
                        this.GetSuspectAccounts(this.state.currentPage)
                      }
                    />
                  </div>
                )}
              </div>
            )}
            {!this.state.dataLoading && (
              <div className="tableContainer ag-theme-alpine">
                <AgGridReact
                  enableRtl={true}
                  autoHeight={true}
                  animateRows={true}
                  enableBrowserTooltips={true}
                  tooltipMouseTrack={true}
                  suppressSizeToFit={false}
                  columnDefs={this.state.columnDefs}
                  localeText={this.state.gridLocaleText}
                  rowData={this.state.rowData}
                  suppressDragLeaveHidesColumns={true}
                  suppressMovable={true}
                  skipHeaderOnAutoSize={false}
                  // onGridReady={this.onGridReady.bind(this)}
                  onFirstDataRendered={this.onFirstDataRendered.bind(this)}
                  rowHeight={window.innerWidth <= 587 ? 40 : 50}
                  headerHeight={window.innerWidth <= 587 ? 40 : 50}
                  frameworkComponents={this.state.frameworkComponents}
                  // onRowClicked={this.onGridRowClicked.bind(this)}
                  // getRowStyle ={function(params){ return { borderWidth:'0px' }}}
                  ref={this.tableGrid}
                  enableCellTextSelection={true}
                  ensureDomOrder={true}
                ></AgGridReact>
              </div>
            )}
            {!this.state.dataLoading && (
              <div
                style={{
                  width: "100%",
                  marginTop: "15px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Paginator
                  currentPage={this.state.currentPage}
                  totalPages={this.state.totalPages}
                  onFirstPageClick={this.onFirstPageClick.bind(this)}
                  onPreviousPageClick={this.onPreviousPageClick.bind(this)}
                  onNextPageClick={this.onNextPageClick.bind(this)}
                  onLastPageClick={this.onLastPageClick.bind(this)}
                />
              </div>
            )}

            {this.state.dataLoading && (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <WhisperSpinner
                  size={50}
                  color="var(--brown1)"
                  frontColor="var(--brown1)"
                  backColor="var(--brown1)"
                  loading={true}
                />
              </div>
            )}
          </div>

          <Modal
            show={this.state.ModalShow}
            size="sm"
            animation={true}
            onHide={this.hideModal.bind(this)}
            centered
          >
            {(this.state.modalType === "suspect" ||
              this.state.modalType === "block") && (
              <div className="settingContainer" style={{ padding: "10px" }}>
                <div className="ModalTitleSM">
                  {this.state.modalType === "suspect"
                    ? "تلفن مشکوک جدید"
                    : "تلفن مسدود جدید"}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    overflow: "auto",
                    marginTop: "20px",
                    padding: "5px",
                    width: "100%",
                  }}
                >
                  <div className="settingItemContainer">
                    <div
                      className="settingLabel"
                      style={{ whiteSpace: "noWrap" }}
                    >
                      شماره موبایل
                    </div>
                    <Form.Control
                      maxLength="11"
                      className={
                        this.state.CPhoneErrorText !== ""
                          ? "inputStyleForm inputError textAlignCenter"
                          : "inputStyleForm textAlignCenter"
                      }
                      style={{ direction: "ltr", maxWidth: "150px" }}
                      placeholder="موبایل"
                      type="text"
                      name="CPhoneValue"
                      onChange={this.textHandleChange.bind(this)}
                      value={this.state.CPhoneValue}
                    />
                  </div>
                </div>

                <div style={{ flex: "1" }} />

                <div
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="تایید"
                      loading={this.state.writingProgress}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.onConfirm.bind(this)}
                    />
                  </div>
                  <div style={{ minWidth: "10px" }} />
                  <div style={{ flex: "0.8" }}>
                    <CustomButton
                      title="انصراف"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={this.hideModal.bind(this)}
                    />
                  </div>
                </div>
              </div>
            )}

            {(this.state.modalType === "delete" ||
              this.state.modalType === "transfer") && (
              <div className="dialogBox">
                {this.state.modalType === "delete"
                  ? "آیا از حذف تلفن مورد نظر از لیست اطمینان دارید؟"
                  : "آیا از انتقال شماره مورد نظر به لیست تلفن‌های مسدود شده مطمئن هستید؟"}

                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    marginTop: "20px",
                    alignItems: "center",
                  }}
                >
                  <div style={{ flex: "1" }}>
                    <CustomButton
                      title="بله"
                      loading={this.state.confirmLoading}
                      imgHeight={20}
                      imgWidth={25}
                      minHeight="35px"
                      img={Tick}
                      onClick={this.onConfirmQuestion.bind(this)}
                    />
                  </div>
                  <div style={{ minWidth: "5px" }} />
                  <div style={{ flex: "0.8" }}>
                    <CustomButton
                      title="خیر"
                      imgHeight={19}
                      backColor="var(--black1)"
                      imgWidth={25}
                      minHeight="35px"
                      img={Cancel}
                      onClick={this.hideModal.bind(this)}
                    />
                  </div>
                </div>
              </div>
            )}
          </Modal>
          {/* <ReactTooltip effect="solid" /> */}
        </div>
      );
    } else {
      return (
        <div className="paymentResultContainer">
          <img
            src={accessdenied}
            alt=""
            style={{
              width: "50%",
              minWidth: "150px",
              maxHeight: "200px",
              objectFit: "contain",
            }}
          />
          <div style={{ marginTop: "30px" }}>
            متاسفانه شما مجوز لازم برای مشاهده این صفحه را ندارید
          </div>
          <div style={{ marginTop: "30px" }}>
            <CustomButton
              title="بازگشت"
              minHeight="35px"
              onClick={this.onBack.bind(this)}
            />
          </div>
        </div>
      );
    }
  }
}
